import { Box, Link, Typography, useMediaQuery } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import React from "react";
import RegisterImage from "../../../assets/images/IlustrasiDaftar.png";

interface RegisterPageLayoutProps {
    children: React.ReactNode;
}

const RegisterPageLayout = ({ children }: RegisterPageLayoutProps) => {
    const theme = useTheme();
    const isPhoneScreen = useMediaQuery(theme.breakpoints.between("xs", "sm"));
    const isTabletScreen = useMediaQuery(theme.breakpoints.down("md"));
    const currentYear = new Date().getFullYear();

    return (
        <Box
            padding={3}
            display="flex"
            justifyContent="center"
            sx={{ backgroundColor: "#45A779" }}
        >
            <Box
                sx={{
                    minHeight: "930px",
                    width: isTabletScreen ? undefined : "fit-content",
                    backgroundColor: "#FFF",
                    display: isPhoneScreen || isTabletScreen ? "flex" : "grid",
                    justifyContent: "center",
                    gridTemplateColumns: isPhoneScreen ? undefined : "1fr 1fr",
                    borderRadius: 1,
                    paddingX: isTabletScreen ? 2 : undefined,
                    paddingY: 2,
                }}
            >
                {!isTabletScreen && (
                    <Box position="relative">
                        <Box
                            sx={{
                                position: "absolute",
                                top: "50%",
                                left: "50%",
                                transform: "translate(-50%, -50%)",
                                height: "90%",
                                width: "90%",
                            }}
                        >
                            <img
                                alt="Ilustrasi Main"
                                src={RegisterImage}
                                width="100%"
                                height="100%"
                                style={{ objectFit: "contain" }}
                            />
                        </Box>
                        <Box
                            position="absolute"
                            bottom={0}
                            left={24}
                            display="flex"
                            justifyContent="center"
                        >
                            <Typography
                                variant="caption"
                                component="div"
                                textAlign="center"
                            >
                                <Link
                                    variant="caption"
                                    target="_blank"
                                    href="https://nore.web.id/"
                                    underline="hover"
                                >
                                    Nore Inovasi
                                </Link>{" "}
                                {`© ${currentYear}. All right reserved`}
                            </Typography>
                        </Box>
                    </Box>
                )}
                {children}
            </Box>
        </Box>
    );
};

export default RegisterPageLayout;
